import { useState, useEffect } from 'react'
import { GetPlanOrganizationOrganizations } from '../services/AnnualPlanService'
import { type PlanOrganizationOrganizations } from '../models/PlanOrganizationOrganizations'
import { handleApiResponse } from '../utils/apiHelpers'

interface UseRcnIsdsType {
  planOrganizationOrgs: PlanOrganizationOrganizations | null
  isLoading: boolean
  errors?: string[]
}
export const usePlanOrganizationOrgs = (planOrgId: number): UseRcnIsdsType => {
  const [planOrganizationOrgs, setPlanOrganizationOrgs] = useState<PlanOrganizationOrganizations | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [errors, setErrors] = useState<string[]>()

  useEffect(() => {
    const getPlanOrganizationOrgs = async (): Promise<void> => {
      setErrors(undefined)
      setIsLoading(true)
      const planOrgOrgs = await handleApiResponse(GetPlanOrganizationOrganizations(planOrgId))
      if (planOrgOrgs != null) setPlanOrganizationOrgs(planOrgOrgs)
      setIsLoading(false)
    }

    void getPlanOrganizationOrgs()
  }, [planOrgId])

  return { planOrganizationOrgs, isLoading, errors }
}
